<template>
  <span class="brand-lockup" :class="{ compact }">
    <span class="brand-symbol" aria-hidden="true">
      <i class="shape top"></i>
      <i class="shape left"></i>
      <i class="shape right"></i>
    </span>
    <span v-if="!markOnly" class="brand-copy">
      <span class="brand-name">bmotik <strong>Recorder</strong></span>
      <span v-if="!compact" class="brand-caption">Captura y entrega profesional</span>
    </span>
  </span>
</template>

<script>
export default {
  name: 'BmotikBrand',
  props: {
    compact: { type: Boolean, default: false },
    markOnly: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.brand-lockup { display: inline-flex; align-items: center; gap: .72rem; min-width: 0; }
.brand-symbol { width: 38px; height: 34px; display: block; position: relative; flex: 0 0 auto; }
.shape { position: absolute; display: block; border-radius: 8px; transform: skew(-16deg) rotate(-7deg); }
.shape.top { width: 29px; height: 10px; left: 5px; top: 2px; background: linear-gradient(90deg, #eb00c7, #8627e8); }
.shape.left { width: 12px; height: 12px; left: 2px; bottom: 3px; background: linear-gradient(145deg, #4e56e9, #00b8ef); }
.shape.right { width: 24px; height: 13px; left: 15px; bottom: 4px; background: linear-gradient(100deg, #0968dc, #00c9ec); }
.brand-copy { min-width: 0; display: flex; flex-direction: column; }
.brand-name { color: #202028; font-size: 1.28rem; line-height: 1; letter-spacing: -.035em; white-space: nowrap; }
.brand-name strong { color: var(--bm-indigo); font-weight: 750; }
.brand-caption { margin-top: .32rem; color: var(--bm-muted); font-size: .58rem; font-weight: 700; letter-spacing: .09em; text-transform: uppercase; white-space: nowrap; }
.compact .brand-symbol { width: 32px; height: 29px; transform: scale(.84); transform-origin: left center; }
.compact .brand-name { font-size: 1.03rem; }
</style>
